import React, { useState } from 'react';
import {
  Box,
  TextField,
  IconButton,
  Typography,
  InputAdornment,
  Tooltip,
  CircularProgress,
  Paper,
  Collapse,
  Button
} from '@mui/material';
import {
  LocationOn as LocationIcon,
  MyLocation as MyLocationIcon,
  Map as MapIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon
} from '@mui/icons-material';
import MapaPicker from '../maps/MapaPicker';

const DireccionInput = ({
  label = 'Direccion',
  value = {},
  onChange,
  requiereCoordenadas = false,
  disabled = false,
  showContacto = true,
  showMap = true
}) => {
  const [loading, setLoading] = useState(false);
  const [mapExpanded, setMapExpanded] = useState(false);

  const handleChange = (field, newValue) => {
    onChange({
      ...value,
      [field]: newValue
    });
  };

  const handleGetLocation = () => {
    if (!navigator.geolocation) {
      alert('Geolocalizacion no soportada en este navegador');
      return;
    }

    setLoading(true);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        onChange({
          ...value,
          latitud: position.coords.latitude,
          longitud: position.coords.longitude
        });
        setLoading(false);
      },
      (error) => {
        console.error('Error obteniendo ubicacion:', error);
        alert('No se pudo obtener la ubicacion');
        setLoading(false);
      }
    );
  };

  const handleMapChange = ({ latitud, longitud, direccion }) => {
    onChange({
      ...value,
      direccion: direccion,
      latitud: latitud,
      longitud: longitud
    });
  };

  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 600, color: 'primary.main' }}>
        {label}
      </Typography>

      <Box sx={{ display: 'flex', gap: 1 }}>
        <TextField
          fullWidth
          placeholder="Direccion completa"
          value={value.direccion || ''}
          onChange={(e) => handleChange('direccion', e.target.value)}
          disabled={disabled}
          size="small"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LocationIcon color="action" />
              </InputAdornment>
            )
          }}
        />

        {showMap && (
          <Tooltip title={mapExpanded ? "Ocultar mapa" : "Seleccionar en mapa"}>
            <IconButton
              onClick={() => setMapExpanded(!mapExpanded)}
              disabled={disabled}
              color={mapExpanded ? "primary" : "default"}
              sx={{ border: '1px solid', borderColor: 'divider' }}
            >
              {mapExpanded ? <ExpandLessIcon /> : <MapIcon />}
            </IconButton>
          </Tooltip>
        )}

        {requiereCoordenadas && !showMap && (
          <Tooltip title="Obtener mi ubicacion">
            <IconButton
              onClick={handleGetLocation}
              disabled={disabled || loading}
              color="primary"
              sx={{ border: '1px solid', borderColor: 'divider' }}
            >
              {loading ? <CircularProgress size={24} /> : <MyLocationIcon />}
            </IconButton>
          </Tooltip>
        )}
      </Box>

      {/* Mapa expandible */}
      {showMap && (
        <Collapse in={mapExpanded}>
          <Box sx={{ mt: 2 }}>
            <MapaPicker
              latitud={value.latitud}
              longitud={value.longitud}
              direccion={value.direccion || ''}
              onChange={handleMapChange}
              disabled={disabled}
              label="Seleccionar ubicacion en el mapa"
              height={250}
            />
          </Box>
        </Collapse>
      )}

      <TextField
        fullWidth
        placeholder="Referencia (opcional)"
        value={value.referencia || ''}
        onChange={(e) => handleChange('referencia', e.target.value)}
        disabled={disabled}
        size="small"
        sx={{ mt: 1.5 }}
      />

      {showContacto && (
        <Box sx={{ display: 'flex', gap: 2, mt: 1.5 }}>
          <TextField
            placeholder="Nombre de contacto"
            value={value.nombre_contacto || ''}
            onChange={(e) => handleChange('nombre_contacto', e.target.value)}
            disabled={disabled}
            size="small"
            sx={{ flex: 2 }}
          />
          <TextField
            placeholder="Telefono"
            value={value.telefono_contacto || ''}
            onChange={(e) => handleChange('telefono_contacto', e.target.value)}
            disabled={disabled}
            size="small"
            sx={{ flex: 1 }}
          />
        </Box>
      )}

      {value.latitud && value.longitud && !mapExpanded && (
        <Typography variant="caption" color="success.main" sx={{ mt: 1, display: 'block' }}>
          Coordenadas: {Number(value.latitud).toFixed(6)}, {Number(value.longitud).toFixed(6)}
        </Typography>
      )}
    </Paper>
  );
};

export default DireccionInput;
